function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.40138 3.10461C9.75749 3.10461 11.6675 5.01462 11.6675 7.37074C11.6675 9.72685 9.75749 11.6369 7.40138 11.6369C5.04526 11.6369 3.13525 9.72685 3.13525 7.37074",
  stroke: "#7850CD",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6256 8.83582C13.4928 9.40102 13.2849 9.94587 13.0073 10.4558",
  stroke: "#7850CD",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.8462 11.9691C11.4257 12.3695 10.9566 12.7155 10.4497 12.9987",
  stroke: "#7850CD",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M7.9668 1C8.54523 1.05124 9.11388 1.18178 9.65675 1.38793",
  stroke: "#7850CD",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M11.3198 2.31873C11.7804 2.67237 12.1885 3.08947 12.532 3.55761",
  stroke: "#7850CD",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M13.4312 5.23926C13.6295 5.78505 13.7471 6.35685 13.7804 6.93661",
  stroke: "#7850CD",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M8.68156 13.642C5.21807 14.3488 1.83736 12.1141 1.13052 8.65065C0.42369 5.18716 2.6584 1.80644 6.12189 1.09961",
  stroke: "#7850CD",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

const SvgLoad = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLoad, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/load.d7113f2a.svg";
export { ForwardRef as ReactComponent };